module.exports = __webpack_public_path__ + "static/media/AJKU-Logo-v1.c913dd6c.png";